import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/toast.css';

// One toast design for the whole app (see toast.css): compact dark pill
// with a status dot, tap anywhere to dismiss. Call sites still pass their
// legacy `style` blobs (darkgreen/darkred/orange blocks) — the colors are
// MAPPED onto variants here and the blob itself is discarded, so every
// existing call upgrades without being touched.

type Variant = 'success' | 'error' | 'warning' | 'info';

const variantFromLegacy = (options: any): Variant => {
  if (options?.variant) return options.variant;
  const bg = String(options?.style?.backgroundColor || '').toLowerCase();
  if (bg.includes('green')) return 'success';
  if (bg.includes('red')) return 'error';
  if (bg.includes('orange') || bg === '#ff9800') return 'warning';
  return 'info';
};

class ToastService {
  public static showToast = async (message: string, options: any = {}) => {
    const TOAST_ID = 'dine-toast';
    const variant = variantFromLegacy(options);

    const toastOptions = {
      position: 'top-center' as const,
      autoClose: options.autoClose || options.autoclose || 2600,
      closeOnClick: true,
      draggable: true,
      hideProgressBar: true,
      closeButton: false,
      icon: false as const,
      className: `dp-toast dp-toast--${variant}`,
    };

    if (!toast.isActive(TOAST_ID)) {
      toast(message, { ...toastOptions, toastId: TOAST_ID });
    } else {
      toast.update(TOAST_ID, { render: message, ...toastOptions });
    }
  };
}

export default ToastService;
